const mfa = {
    title: '多重因素驗證',
    description: '添加多重因素驗證以提升登入體驗的安全性。',
    factors: '因素',
    multi_factors: '多重因素',
    multi_factors_description: '用戶需要驗證其中一個已啟用的因素以完成兩步驗證。',
    totp: '驗證器應用程式',
    otp_description: '連結Google身分驗證器等應用程式，以驗證一次性密碼。',
    webauthn: '通行金鑰',
    webauthn_description: '透過瀏覽器支援的方式進行驗證：生物識別、手機掃描或安全密鑰等。',
    webauthn_domain_tip: '網路身分驗證（WebAuthn）會將公開密鑰綁定至特定網域。變更服務網域將導致用戶無法使用現有通行密鑰進行驗證。',
    backup_code: '備用代碼',
    backup_code_description: '在用戶設定任何多因素驗證方法後生成 10 個一次性備用代碼。',
    backup_code_setup_hint: '當用戶無法驗證上述多因素驗證因素時，可使用備用選項。',
    backup_code_error_hint: '要使用備用代碼，你需要至少再添加一種多因素驗證方法以完成用戶驗證。',
    email_verification_code: 'Email驗證碼',
    email_verification_code_description: '連結電子郵件地址以接收和驗證驗證碼。',
    phone_verification_code: 'SMS驗證碼',
    phone_verification_code_description: '連結電話號碼以接收和驗證SMS驗證碼。',
    policy: '政策',
    policy_description: '設定登入和註冊流程的多因素驗證政策。',
    two_step_sign_in_policy: '登入時的雙重驗證政策',
    user_controlled: '用戶可自行啟用或停用多因素驗證',
    user_controlled_tip: '用戶可在首次登入或註冊時跳過多因素驗證設定，或在帳戶設定中啟用/停用它。',
    mandatory: '用戶必須在登入時使用多因素驗證',
    mandatory_tip: '用戶必須在首次登入或註冊時設定多因素驗證，並在之後的所有登入中使用。',
    require_mfa: '需要多因素驗證',
    require_mfa_label: '啟用此選項可將雙重驗證設為存取應用程式的強制要求。若停用，用戶可自行決定是否啟用多因素驗證。',
    require_mfa_optional: '選用多因素驗證:讓用戶自行選擇是否啟用多因素驗證以加強帳戶安全',
    require_mfa_adaptive: '自適應多因素驗證:只在登入風險較高時(例如新國家／長期未活動)才要求使用多因素驗證',
    require_mfa_mandatory: '強制多因素驗證:所有用戶每次登入時都必須完成多因素驗證',
    set_up_prompt: '多因素驗證設定提示',
    no_prompt: '不要求用戶設定多因素驗證',
    prompt_at_sign_in_and_sign_up: '在註冊期間要求用戶設定多因素驗證（可跳過的一次性提示）',
    prompt_only_at_sign_in: '在註冊後的下次登入時要求用戶設定多因素驗證（可跳過的一次性提示）',
    prompt_at_sign_in_and_sign_up_mandatory: '在註冊時要求用戶設定多因素驗證。（不可跳過）',
    prompt_only_at_sign_in_mandatory: '在註冊後的下次登入嘗試時要求用戶設定多因素驗證。（不可跳過）',
    set_up_organization_required_mfa_prompt: '組織啟用多因素驗證後要求用戶設定的多因素驗證提示',
    prompt_at_sign_in_non_skippable: '在下次登入時要求用戶設定多因素驗證（不可跳過）',
    email_primary_method_tip: 'Email驗證碼已是你的主要登入方法。為了保持安全性，不能重複用於多因素驗證。',
    phone_primary_method_tip: 'SMS驗證碼已是你的主要登入方法。為了保持安全性，不能重複用於多因素驗證。',
    no_email_connector_warning: '尚未設定電郵連接器。在完成設定前，用戶無法使用電郵驗證碼進行多因素驗證。在「連接器」中<a>{{link}}</a>。',
    no_sms_connector_warning: '尚未設定SMS連接器。在完成設定前，用戶無法使用SMS驗證碼進行多因素驗證。在「連接器」中<a>{{link}}</a>。',
    no_email_connector_error: '沒有電郵連接器無法啟用電郁驗證碼多因素驗證。請先設定電郵連接器。',
    no_sms_connector_error: '沒有SMS連接器無法啟用SMS驗證碼多因素驗證。請先設定SMS連接器。',
    setup_link: '設定',
    trusted_device: {
        title: '受信任裝置',
        description: '讓受信任的瀏覽器在目前多因素驗證流程要求驗證時自動完成多因素驗證驗證。',
        enable_title: '啟用受信任裝置',
        enable_description: '允許用戶完成合資格的多因素驗證因素驗證後信任此瀏覽器。',
        duration_title: '信任期限（天）',
        duration_error: '請輸入 {{min}} 至 {{max}} 之間的整數。',
        duration_note: '信任期限的變更只適用於之後加入的受信任裝置。',
        organization_allow_title: '允許受信任裝置',
        organization_allow_tip: '組織只能收緊租戶的受信任裝置策略；租戶策略關閉時，組織不能啟用此功能。',
        organization_allow_description: '允許此組織的成員使用受信任裝置完成驗證。',
        organization_global_disabled: '請先在租戶多因素驗證設定中啟用受信任裝置，再為此組織允許此功能。',
        management_description: '管理此使用者完成多因素驗證後信任的瀏覽器。移除後，該瀏覽器下次登入時需要再次完成多因素驗證。',
        management_hint: '最近的位置只供參考。',
        management_empty: '此使用者沒有有效的受信任裝置。',
        management_deletion_confirmation: '確定要移除 {{name}} 嗎？該瀏覽器下次登入時需要再次完成多因素驗證。',
        management_removed: '受信任裝置已移除。',
    },
};
export default Object.freeze(mfa);
